<script>

import AwardManagement from '@/views/AadenPages/memberShipReborn/Award/AwardManagement.vue'

export default {
  name: 'AwardIndex',
  components: {
    AwardManagement
  }
}
</script>

<template>
  <div>
    <award-management />
  </div>
</template>

<style scoped>

</style>
